import Image, { StaticImageData } from 'next/image'
import {
  WizardQuoteCardRoot,
  Card,
  QuoteText,
  Attribution,
  AvatarWrapper,
  AuthorInfo,
  AuthorName,
  AuthorTitle,
} from './WizardQuoteCard.styles'

type WizardQuoteCardProps = {
  quote: string
  authorName: string
  authorTitle?: string
  avatarSrc: StaticImageData
  avatarAlt: string
  avatarType?: 'photo' | 'logo'
}

export const WizardQuoteCard = ({
  quote,
  authorName,
  authorTitle,
  avatarSrc,
  avatarAlt,
  avatarType = 'photo',
}: WizardQuoteCardProps) => {
  return (
    <WizardQuoteCardRoot>
      <Card css={avatarType === 'logo' ? { gap: '8px' } : undefined}>
        <QuoteText>{quote}</QuoteText>
        <Attribution>
          <AvatarWrapper>
            {avatarType === 'photo' ? (
              <Image
                src={avatarSrc}
                alt={avatarAlt}
                width={40}
                height={40}
                objectFit="cover"
                style={{ borderRadius: '$pill' }}
              />
            ) : (
              <Image
                src={avatarSrc}
                alt={avatarAlt}
                width={35}
                height={9}
                objectFit="contain"
              />
            )}
          </AvatarWrapper>
          <AuthorInfo>
            <AuthorName>{authorName}</AuthorName>
            {authorTitle && <AuthorTitle>{authorTitle}</AuthorTitle>}
          </AuthorInfo>
        </Attribution>
      </Card>
    </WizardQuoteCardRoot>
  )
}

WizardQuoteCard.displayName = 'WizardQuoteCard'
